// eslint-disable-next-line import/prefer-default-export
export const searchTags = (term) => {
  const preProcessed = term.trim().toLowerCase();

  return fetch(
    `/api/v1/tags/search?term=${encodeURIComponent(preProcessed)}`,
    {
      credentials: 'same-origin',
    },
  )
    .then((res) => res.json())
    .then((data) => data.tags);
};
